import { hasYesOrNo } from 'models/validate';
import { ValidateJSModel } from 'forms/shared/types';
import legalAssociationsInternationalAndDomesticTerrorismAdvocacyItemValidator from './validators/items';
import { LegalAssociationsInternationalAndDomesticTerrorismAdvocacyModel } from './types';

const legalAssociationsInternationalAndDomesticTerrorismAdvocacyValidator: ValidateJSModel<LegalAssociationsInternationalAndDomesticTerrorismAdvocacyModel> = {
  HasInternationalAndDomesticTerrorismAdvocacy: { presence: true, hasValue: { validator: hasYesOrNo } },

  List: (value, attributes) => {
    if (attributes?.HasInternationalAndDomesticTerrorismAdvocacy?.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: legalAssociationsInternationalAndDomesticTerrorismAdvocacyItemValidator },
      };
    }

    return {};
  },
};

export default legalAssociationsInternationalAndDomesticTerrorismAdvocacyValidator;
